import { Grid, Link, Typography } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import React, { useCallback } from 'react';
import { Link as RouteLink, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

import usePasswordResetRequest from 'core/hooks/usePasswordResetRequest';
import passwordResetRequestSchema, { PasswordResetRequestSchema } from 'core/schemas/passwordResetRequest';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';

const Container = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
`;

export default function PasswordResetRequest({
  location
}: RouteComponentProps) {
  const { request, requested } = usePasswordResetRequest();

  const onSubmit: FormSubmitHandler<PasswordResetRequestSchema> = useCallback(
    ({ email }, form) => request(email!),
    [request]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        email: new URLSearchParams(location.search).get('email')
      }}
      validationSchema={passwordResetRequestSchema}
    >
      <Grid container component={Container} direction="column" spacing={4}>
        <Grid item>
          <Typography variant="h1">Salasanan palauttaminen</Typography>
        </Grid>

        <Grid item>
          <Typography color="textSecondary">
            Lähetämme sähköpostiisi linkin, josta pääset vaihtamaaan salasanasi.
          </Typography>
        </Grid>

        <Grid item>
          <InputField
            type="email"
            name="email"
            autoFocus
            placeholder="Syötä käyttäjätunnus"
            margin="none"
          />
        </Grid>

        <Grid item>
          <SubmitButton
            variant="contained"
            color="primary"
            fullWidth
            disabled={requested}
          >
            Lähetä
          </SubmitButton>
        </Grid>

        <Grid item>
          <Typography align="center">
            <Field name="email">
              {(props: FieldProps) => {
                const email = props.field.value;

                return (
                  <Link
                    component={RouteLink}
                    to={{
                      pathname: '/login',
                      search: email ? `?email=${email}` : undefined
                    }}
                  >
                    Kirjaudu sisään
                  </Link>
                );
              }}
            </Field>
          </Typography>
        </Grid>
      </Grid>
    </Form>
  );
}
